import withAPIAction from 'helpers/withAPIAction'
import {
  PurchaseListReq,
  CreatePurchaseReq,
  UpdatePurchaseReq,
  DeletePurchaseReq,
  PurchaseDetailReq,
  UpdatePurchaseStatusReq,
  LogsReq,
  CountReq,
} from './types'
import {
  getPurchaseListAction,
  createPurchaseAction,
  updatePurchaseAction,
  deletePurchaseAction,
  getPurchaseDetailAction,
  updatePurchaseStatusAction,
  getLogsAction,
  getCountAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import { getRequestString } from 'helpers/format'

export const purchaseListAPI = (data: PurchaseListReq, token: string, xmid: string) => {
  return withAPIAction<PurchaseListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.purchaseList}`,
    data,
    token,
    xmid,
  })(getPurchaseListAction)
}

export const createPurchaseAPI = (data: CreatePurchaseReq, token: string, xmid: string) => {
  return withAPIAction<CreatePurchaseReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.createPurchase,
    data,
    token,
    xmid,
  })(createPurchaseAction)
}

export const updatePurchaseAPI = (data: UpdatePurchaseReq, token: string, xmid: string) => {
  return withAPIAction<UpdatePurchaseReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.createPurchase,
    data,
    token,
    xmid,
  })(updatePurchaseAction)
}

export const deletePurchaseAPI = (data: DeletePurchaseReq, token: string, xmid: string) => {
  return withAPIAction<DeletePurchaseReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.deletePurchase,
    data,
    token,
    xmid,
  })(deletePurchaseAction)
}

export const getPurchaseDetailAPI = (data: PurchaseDetailReq, token: string, xmid: string) => {
  const endPoint = APIPath.getPurchaseByID.replace(':id', data.id.toString())
  return withAPIAction<PurchaseDetailReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(getPurchaseDetailAction)
}

export const updatePurchaseStatusAPI = (data: UpdatePurchaseStatusReq, token: string, xmid: string) => {
  return withAPIAction<UpdatePurchaseStatusReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.updatePurchaseStatus,
    data,
    token,
    xmid,
  })(updatePurchaseStatusAction)
}

export const getPurchaseLogsAPI = (data: LogsReq, token: string, xmid: string) => {
  return withAPIAction<LogsReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.getPurchaseLogs,
    data,
    token,
    xmid,
  })(getLogsAction)
}

export const getCountAPI = (data: CountReq, token: string, xmid: any) => {
  return withAPIAction<CountReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.countPurchase}`,
    data,
    token,
    xmid,
  })(getCountAction)
}

export const getCountPurchaseReceiptAPI = (data: CountReq, token: string, xmid: any) => {
  return withAPIAction<CountReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.countPurchaseReceipt}`,
    data,
    token,
    xmid,
  })(getCountAction)
}
